import { render } from "./IndicatorViz.vue?vue&type=template&id=6a90139b"
import script from "./IndicatorViz.vue?vue&type=script&lang=js"
export * from "./IndicatorViz.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__